import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Box, Grid, Typography, TextField } from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { blockInvalidChar } from "utils/Regex";
import {
  getRateCard,
  postRateCard,
  getSubCity,
  clearSubCity,
} from "redux/actions/UserRateCard";
import Loader from "components/loader/Loader";
import CommonEditableTable from "components/commonEditableTable/CommonEditableTable";
import { ratecardFilters } from "./RateCardData";
import { rateCardFiltersEnum } from "utils/enumObj";

function RateCard({ type, disabled, companyContractId }) {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const autoCompleteRef = useRef(null);

  const carData = useSelector((state) => state?.userCar?.userCar?.data?.body);
  const subCityData = useSelector((state) => state?.userSubCity?.userSubCity?.data);
  const dutyTypeData = useSelector(
    (state) => state?.userDutyType?.dutyTypeList?.data
  );
  const cityData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );

  //selectd Company city, duty type and vehicle

  const rateCardData = useSelector(
    (state) => state?.userRateCard?.userRateCard?.data
  );
  const loader = useSelector((state) => state?.userRateCard?.loading);
  const onboardedCompanyData = useSelector(
    (state) => state?.addCompany?.onBoardedCompay?.data
  );
  const onboardedUpdateCompanyData = useSelector(
    (state) => state?.updateCompany?.onBoardedCompay?.data
  );

  const companyProfile = useSelector(
    (state) => state?.userCompanyDetails?.companyDetails
  );
  const contractId =
    type === "companyProfile"
      ? companyProfile?.Contracts?.[0]?.CompanyContracts?.ContractId
      : companyContractId;

  const companyId =
    onboardedCompanyData?.id ||
    onboardedUpdateCompanyData?.Contracts?.[0]?.CompanyContracts?.CompanyId;

  const cityOptions =
    cityData?.length > 0
      ? cityData.map((val) => {
          return { name: val?.name, id: val?.id };
        })
      : [];

  const subCityOptions = subCityData?.length > 0
    ? subCityData?.map((val) => ({ name: val?.name, id: val?.id }))
    : [];

  const dutyOptions =
    dutyTypeData?.length > 0
      ? dutyTypeData?.map((val) => ({ id: val.dutyTypeId, name: val.name }))
      : [];

  const carOptions =
    carData?.length > 0
      ? carData?.map((val) => ({ id: val?.id, name: val?.carType }))
      : [];

  const [filterValues, setFilterValues] = useState({
    cityType: cityOptions?.length > 0 ? cityOptions?.[0] : "",
    dutyType: dutyOptions?.length > 0 ? dutyOptions?.[0] : "",
    carType: carOptions?.length > 0 ? carOptions?.[0] : "",
    subCityType: "",
  });


  useEffect(() => {
      const filterValueData = {
        cityType: cityOptions?.[0],
        dutyType: dutyOptions?.[0],
        carType: carOptions?.[0],
      };

      setFilterValues(filterValueData);
      
      const data = {
        carType: filterValueData?.carType?.id,
        type: filterValueData?.dutyType?.id,
        baseFuelPrice: parseFloat(fuelBase),
        location: filterValueData?.cityType?.id,
        contractId: contractId,
      };
      dispatch(getRateCard(data));
  }, []);

  const [slabBtn, setSlabBtn] = useState(true);
  const fuelBasePrice = "102";
  const [fuelBase, setFuelBase] = useState(fuelBasePrice);
  const [isEditable, setIsEditable] = useState(false);
  const [subCityStatus, setSubCityStatus] = useState(3);

  useEffect(() => {
    const fuelPrice = rateCardData?.outStationRates?.length
    ? rateCardData?.outStationRates?.[0]?.baseFuelPrice
    : rateCardData?.rentalRate?.[0]?.baseFuelPrice
    ? rateCardData?.rentalRate?.[0]?.baseFuelPrice
    : rateCardData?.length  
    ? rateCardData?.[0]?.baseFuelPrice 
    : "";
    
    if (fuelPrice) {
      setFuelBase(fuelPrice);
    } else {
      setFuelBase(fuelBasePrice);
    }
  }, [rateCardData]);

  function isNumeric(value) {
    return (
      /^[0-9.]*$/.test(value) && !value.includes("e") && !value.includes("-")
    );
  }

  const handleFuelBaseChange = (event) => {
    if (isNumeric(event.target.value)) {
      setFuelBase(event.target.value.trim());
    }
  };

  const handleEditClick = () => {
    setIsEditable(!isEditable); // Toggle editable state
    ref.current.disabled = false;
    ref.current.focus();
  };

  const handleBlur = () => {
    if (fuelBase?.length < 1) {
      setFuelBase(fuelBasePrice);
    }
    setIsEditable(false); // Disable editable state on blur
  };

  const onSubmit = (data) => {
    const dataList = {
      ...data,
      carType: filterValues?.carType?.id,
      type: filterValues?.dutyType?.id,
      baseFuelPrice: parseFloat(fuelBase),
      location: filterValues?.cityType?.id,
      subLocation: filterValues?.subCityType?.id || "",
      contractId: contractId,
    };
    dispatch(postRateCard(dataList));
  };


  const handleChange = (newValue, name) => {
    const filterTypesData = filterValues;
    filterTypesData[name] = newValue;

    setFilterValues(filterTypesData);

      let payloadData = {
        contractId: contractId,
        carType: filterValues?.carType?.id,
        type: filterValues?.dutyType?.id,
        location: filterValues?.cityType?.id,
        subCity: filterValues?.subCityType?.id,
      };

      if (name === rateCardFiltersEnum?.dutyType) {
        payloadData = {
          ...payloadData,
          type: newValue?.id,
        };

        if(newValue?.id === 4) {
          setSubCityStatus(0);
        } else {
          setSubCityStatus(3);
        }

      } else if (name === rateCardFiltersEnum?.carType) {
        payloadData = {
          ...payloadData,
          carType: newValue?.id,
        };
      } else if (name === rateCardFiltersEnum?.cityType) {
        payloadData = {
          ...payloadData,
          location: newValue?.id,
        };
        dispatch(clearSubCity());
        setFilterValues({...filterValues, subCityType: {id: "", name: ""}});
        dispatch(getSubCity(newValue?.id))
      }
        else if (name === rateCardFiltersEnum?.subCityType) {
          payloadData = {
            ...payloadData,
            subCity: newValue?.id,
          };
       
      }
      dispatch(getRateCard(payloadData));
  };

  const handleOptions = (name) => {
    switch (name) {
      case "dutyType":
        return dutyOptions;
      case "carType":
        return carOptions;
      case "cityType":
        return cityOptions;
        case "subCityType":
          return subCityOptions;
      default:
        return [];
    }
  };

  return (
    <div>
      {loader ? (
        <Loader height={"50vh"} />
      ) : (
        <div className={`mt0`}>
          {type !== "companyProfile" && (
            <Typography
              variant="head3"
              component={"div"}
              className="colorBlack  pt20 fw600 alignItem"
            >
              Rate Card Details
            </Typography>
          )}

          {/* ---Filter Section--- */}
          <Grid
            container
            gap={2}
            flexWrap={"nowrap"}
            className="mt0 justifyBetween flexRow"
          >
            {/* ---Filter Section--- */}
            <Grid
              container
              gap={2}
              flexWrap={"nowrap"}
              direction="row"
              justifyContent="space-between"
              alignitem="center"
              className="mt30"
            >
              {ratecardFilters &&
                ratecardFilters?.filter((filterData) => filterData?.id !== subCityStatus).map((filterData, index) => (
                  <Grid
                    item
                    md={3}
                    sm={6}
                    xs={12}
                    className="customAutoComplete rateCardAutocomplete"
                  >
                    <Autocomplete
                      popupIcon={<ExpandMoreRoundedIcon />}
                      value={filterValues[filterData?.name]}
                      onChange={(event, value) => {
                        handleChange(value, filterData?.name);
                      }}
                      disableClearable={filterData?.name !== "subCityType"}
                      getOptionLabel={(option) => option.name}
                      id="controllable-states-demo"
                      disabled={filterData?.name === "subCityType" ? !subCityData?.length > 0 : false}
                      options={handleOptions(filterData?.name) || []}
                      renderInput={(params) => (
                        <TextField {...params} inputRef={autoCompleteRef} />
                      )}
                    />
                  </Grid>
                ))}
              <Grid
                item
                container
                md={3}
                sm={6}
                xs={12}
                className="customAutocomplete rateCardBaseRate justifyCenter flexRow"
              >
                <Box item role="presentation" className="justifyCenter">
                  <Typography
                    variant="body3"
                    className="fw400"
                    sx={{ color: disabled ? "colorBlack" : "colorGrey" }}
                  >
                    Base Fuel Rate ₹
                  </Typography>
                  <Box item className="tableDis">
                    <input
                      type="number"
                      placeholder="Base Fuel"
                      role="presentation"
                      name="fuelBase"
                      id="input-with-icon-adornment"
                      value={fuelBase}
                      className={`baseFuelPrice ${
                        !isEditable ? "colorGrey" : "colorBlack"
                      }`}
                      onChange={handleFuelBaseChange}
                      disabled={!isEditable}
                      onBlur={handleBlur}
                      onKeyDown={(e) => {
                        blockInvalidChar(e);
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent form submission
                          setIsEditable(false); // Set disabled state to true
                        }
                      }}
                      ref={ref}
                    />
                  </Box>
                  {!isEditable && !disabled && (
                    <Box item>
                      <BorderColorOutlinedIcon
                        onClick={handleEditClick}
                        role="presentation"
                      />
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <CommonEditableTable
            type={type}
            slabBtn={slabBtn}
            setSlabBtn={setSlabBtn}
            fuelBase={fuelBase}
            rateCardData={rateCardData}
            locationData={filterValues?.cityType}
            companyId={companyId}
            onSubmitData={onSubmit}
            trip={filterValues?.dutyType}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

export default RateCard;
